import React, { PureComponent } from 'react'
import queryString from 'query-string'
import { getPrintPreview } from './utils'
import { parseHtmlForReact } from '../helpers'
//import '../../assets/css/textBoxList.css'

class TextBoxList extends PureComponent {
    constructor(props) {
        super(props)
        const { store, question } = props
        const { form_data } = store
        const { options } = question.optionSet

        const questionData = options.reduce((map, option) => {
            map[option.id] = ''
            return map
        }, {})

        if (form_data.has(question.id)) {
            const { data } = form_data.get(question.id)
            Object.keys(data).forEach((optionId) => {
                questionData[optionId] = data[optionId]
            })
        }
        this.data = questionData
    }

    getContent = () => {
        const { question, store } = this.props
        const { options } = question.optionSet
        return options.filter(o => o.willDisplay !== false).map(option => (
            <div>
                <label>{parseHtmlForReact(store.getOptionTitle(option, question))}</label>
                <input type='text' name={option.id} onChange={this.onChange} defaultValue={this.data[option.id]}/>
            </div>
        ))
    }

    onChange = (e) => {
        const { store, question } = this.props
        console.log(`onChange ${e.target.value} ${e.target.name}`)
        this.data[e.target.name] = e.target.value
        store.addFormResponse(question, this.data)
    }

    render() {
        const { store, question } = this.props
        const content = this.getContent()
        return (
            <div className='TL'>
                {getPrintPreview(question, store)}
                {content}
            </div>
        )
    }
}

export default TextBoxList
